
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexzbC2893I7Gyx_djow8ucTdcAg0k2cIDlrlN1FXTYjhAMeta } from "/home/ubuntu/prod_craftstory_temp/src/pages/index.vue?macro=true";
import { default as _91_46_46_46all_9318X7M3__45tmZtaa4eSZl5RZkKtUPJhINEhJX9xQ3Sm3YMeta } from "/home/ubuntu/prod_craftstory_temp/src/pages/[...all].vue?macro=true";
import { default as indexKuCnMZWjny5PweYdTVDR6lqSfZru_4546t4rl1hvV27psMeta } from "/home/ubuntu/prod_craftstory_temp/src/domains/auth/pages/auth/index.vue?macro=true";
import { default as logoutq8UmWQEbwet1xcv3zI8uD418km_457ANzCKFzvryqn8VoMeta } from "/home/ubuntu/prod_craftstory_temp/src/domains/auth/pages/auth/logout.vue?macro=true";
import { default as signinna6E_Mg8vYq2L0MraTitwSKfA4wH01k4Ve8MlUt5DL8Meta } from "/home/ubuntu/prod_craftstory_temp/src/domains/auth/pages/auth/signin.vue?macro=true";
import { default as signupxE6GWi50q9M8dgSdtr0GjpEkJyrRRnEnW0gyLwyY52EMeta } from "/home/ubuntu/prod_craftstory_temp/src/domains/auth/pages/auth/signup.vue?macro=true";
import { default as restoreC6ACX5Yq0r4PwhcomreJiz_45poGMIr7vt06beoJJhaukMeta } from "/home/ubuntu/prod_craftstory_temp/src/domains/auth/pages/auth/restore.vue?macro=true";
import { default as index4FkiegdCupbsP4pggJK4_45CETUUMIJynAWmxlPrL_rU0Meta } from "/home/ubuntu/prod_craftstory_temp/src/domains/editor/pages/editor/index.vue?macro=true";
import { default as index7xNu1MaxqX_45M5DhDbUEm89l5PjDrcfkfzx01srZ_btwMeta } from "/home/ubuntu/prod_craftstory_temp/src/domains/ai-wizard/pages/ai-wizard/index.vue?macro=true";
import { default as indexXNJid0dcTp24KMf0kMccp_45VanAZWqsdKMbOB9_45Gi1g4Meta } from "/home/ubuntu/prod_craftstory_temp/src/domains/dashboard/pages/dashboard/index.vue?macro=true";
import { default as indext_45xVUHA111ijnONGBVOntCxOxWEOF2brEzKtmI1_4514YMeta } from "/home/ubuntu/prod_craftstory_temp/src/domains/editor/pages/editor/[slug]/index.vue?macro=true";
import { default as Assets6Gx4soCyUjTH_2ofG9O1MLAFe4JcH4B4ixfFEWtceisMeta } from "/home/ubuntu/prod_craftstory_temp/src/domains/editor/pages/editor/[slug]/Assets.vue?macro=true";
import { default as Avatarsu_8iLTWVLXnbiZgr_BVaZ5wZ_Rn4x_Gb0EoXd44gIewMeta } from "/home/ubuntu/prod_craftstory_temp/src/domains/editor/pages/editor/[slug]/Avatars.vue?macro=true";
import { default as Scriptsz9AhPXb2UwvNwd5H9TklSUVelABebuNRsVHUqdzbHAQMeta } from "/home/ubuntu/prod_craftstory_temp/src/domains/editor/pages/editor/[slug]/Scripts.vue?macro=true";
import { default as indexTgL2Eoot3sMNgWhK80ZmaD2q4zlFlSQsst03lh9fmMQMeta } from "/home/ubuntu/prod_craftstory_temp/src/domains/dashboard/pages/dashboard/projects/index.vue?macro=true";
import { default as BackgroundsHYmgNBdsFmUii6RQxW2ijEcnXvLBe8wtt2wmd0ZZUgYMeta } from "/home/ubuntu/prod_craftstory_temp/src/domains/editor/pages/editor/[slug]/Backgrounds.vue?macro=true";
import { default as index7tkitBwwKCMp9nuAYBlYv9zrItlLIJ_xOtjF4RK5npMMeta } from "/home/ubuntu/prod_craftstory_temp/src/domains/dashboard/pages/dashboard/projects/videos/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/pages/index.vue")
  },
  {
    name: "all",
    path: "/:all(.*)*",
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/pages/[...all].vue")
  },
  {
    name: "Auth",
    path: "/auth",
    meta: indexKuCnMZWjny5PweYdTVDR6lqSfZru_4546t4rl1hvV27psMeta || {},
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/auth/pages/auth/index.vue")
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/auth/pages/auth/logout.vue")
  },
  {
    name: "auth-signin",
    path: "/auth/signin",
    meta: signinna6E_Mg8vYq2L0MraTitwSKfA4wH01k4Ve8MlUt5DL8Meta || {},
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/auth/pages/auth/signin.vue")
  },
  {
    name: "auth-signup",
    path: "/auth/signup",
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/auth/pages/auth/signup.vue")
  },
  {
    name: "auth-restore",
    path: "/auth/restore",
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/auth/pages/auth/restore.vue")
  },
  {
    name: "EditorPage",
    path: "/editor",
    meta: { ...(index4FkiegdCupbsP4pggJK4_45CETUUMIJynAWmxlPrL_rU0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/editor/pages/editor/index.vue")
  },
  {
    name: "AiWizard",
    path: "/ai-wizard",
    meta: { ...(index7xNu1MaxqX_45M5DhDbUEm89l5PjDrcfkfzx01srZ_btwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/ai-wizard/pages/ai-wizard/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: {"middleware":["to-projects"]},
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/dashboard/pages/dashboard/index.vue")
  },
  {
    name: "editor-slug",
    path: "/editor/:slug()",
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/editor/pages/editor/[slug]/index.vue")
  },
  {
    name: "EditorPageAssets",
    path: "/editor/:slug()/Assets",
    meta: { ...(Assets6Gx4soCyUjTH_2ofG9O1MLAFe4JcH4B4ixfFEWtceisMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/editor/pages/editor/[slug]/Assets.vue")
  },
  {
    name: "EditorPageAvatars",
    path: "/editor/:slug()/Avatars",
    meta: { ...(Avatarsu_8iLTWVLXnbiZgr_BVaZ5wZ_Rn4x_Gb0EoXd44gIewMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/editor/pages/editor/[slug]/Avatars.vue")
  },
  {
    name: "EditorPageScripts",
    path: "/editor/:slug()/Scripts",
    meta: { ...(Scriptsz9AhPXb2UwvNwd5H9TklSUVelABebuNRsVHUqdzbHAQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/editor/pages/editor/[slug]/Scripts.vue")
  },
  {
    name: "DashboardPageProjects",
    path: "/dashboard/projects",
    meta: { ...(indexTgL2Eoot3sMNgWhK80ZmaD2q4zlFlSQsst03lh9fmMQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/dashboard/pages/dashboard/projects/index.vue")
  },
  {
    name: "EditorPageBackgrounds",
    path: "/editor/:slug()/Backgrounds",
    meta: { ...(BackgroundsHYmgNBdsFmUii6RQxW2ijEcnXvLBe8wtt2wmd0ZZUgYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/editor/pages/editor/[slug]/Backgrounds.vue")
  },
  {
    name: "DashboardPageVideos",
    path: "/dashboard/projects/videos",
    meta: { ...(index7tkitBwwKCMp9nuAYBlYv9zrItlLIJ_xOtjF4RK5npMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/dashboard/pages/dashboard/projects/videos/index.vue")
  }
]